module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_11.45ecfa92.png";